@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.designContent {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.designerResponse {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.designPreviewContainer {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;

  &.fullWidth {
    grid-template-columns: 1fr;
  }
}

.designPreview {
  border-radius: 10px;
  border: 1px solid var(--dark-4);
  overflow: hidden;
  position: relative;
  cursor: pointer;
  outline: none;

  &:not(.fullWidth) {
    height: 100%;
  }

  &.fullWidth {
    width: 100%;
    max-width: 600px;
  }

  .designPreviewOverlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 8px;
    background: rgba(0, 0, 0, 0.4);
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-end;
    gap: 5px;
    z-index: 1;

    .insertButtonContainer {
      background-color: var(--light-80);
      border-radius: 4px;
    }
  }
}

.modalBody {
  display: grid;
  grid-template-columns: 60px 1fr 60px;
  align-items: center;
  justify-items: center;

  &:not(.landscape) {
    height: 60vh;
  }

  &.landscape {
    height: 40vh;
  }
}

.designPreviewLoading {
  position: relative;
  cursor: default;

  .designPreview {
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.05) 0%, rgba(0, 0, 0, 0.05) 100%), rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(2px);
    position: relative;
    overflow: hidden;

    &::before,
    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 1;
    }

    &::after {
      z-index: 2;
    }
  }

  .progressContainer {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 3;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 3px;

    .progressOverlay {
      width: 50px;

      .progressBar {
        position: relative;
        height: 7px;
        background-color: var(--dark-15);
        border-radius: 99px;
        overflow: hidden;
        padding: 1px;

        .progressFill {
          height: 100%;
          background-color: var(--light-100);
          border-radius: 99px;
          transition: width 0.1s ease-out;
        }
      }
    }
  }
}
